var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.faq)?_c('div',{staticClass:"app-newsletter"},[_c('div',{staticClass:"wrapper top-space",domProps:{"innerHTML":_vm._s(_vm.$store.state.faq.content)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }